import * as React from 'react';
import { SVGProps } from 'react';

const WhitePlayIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={32} height={36} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="m29.324 14.026-22-12.412a4.685 4.685 0 0 0-4.711.036 4.528 4.528 0 0 0-2.28 3.938v24.824a4.528 4.528 0 0 0 2.28 3.938 4.687 4.687 0 0 0 4.711.036l22-12.412a4.543 4.543 0 0 0 0-7.948Z"
      fill="#fff"
    />
  </svg>
);

export default WhitePlayIcon;
